import { useCadastrarEditarProdutoContext } from "../../../../contexts/CadastrarEditarProdutoContext";
import { ConfiguracaoComboContainer } from "../../../../containers/ConfiguracaoComboContainer";
import { ConfiguracaoProdutosComboContainer } from "../../../../containers/ConfiguracaoProdutosComboContainer";

export const CadastrarComboContainer = () => {
    const { step } = useCadastrarEditarProdutoContext();

    // KDS, estoque e fiscal são configurados por produto do combo (na etapa "Produtos"),
    // então o combo tem apenas: Configuração (0) e Produtos (1).
    return (
        <>
            {step === 0 && <ConfiguracaoComboContainer />}
            {step === 1 && <ConfiguracaoProdutosComboContainer />}
        </>
    );
};
